<template>
  <div>
    <div class="print-box">
      <div class="print-des">
        纸张尺寸：{{ pageW }}mm * {{ pageH }}mm；水平间距：{{ mouldData.space }}mm；垂直间距：{{ mouldData.gap }}mm；<br>
        一码大小：{{ oneCodeW }}mm * {{ pageH }}mm
      </div>
      <div :style="{'position':'relative','overflow':'hidden','word-break':'break-all','background': '#999','color':'#000','width':`${pageW*multiple}px`, 'height':`${pageH*multiple}px`, 'display': 'flex', 'justify-content': 'space-between'}">
        <div
          v-for="index of mouldData.print_mode"
          :key="index"
          :style="{'overflow':'hidden','box-sizing':'border-box', 'background': '#fff','width':`${oneCodeW*multiple}px`, 'height':`${pageH*multiple}px`}"
        ></div>
        <template v-for="(item, index) in mouldData.unit">
          <!-- 二维码 -->
          <img
            v-if="item.type==='QRCODE'"
            :key="'comp'+index"
            :src="item.picture"
            class="comp"
            :style="{'width':`${item.width*multiple}px`,'height':`${item.height*multiple}px`, 'top':`${item.top*multiple}px`, 'left':`${item.left*multiple}px`}"
          />
          <!-- 图片 -->
          <img
            v-if="item.type==='PIC'"
            :key="'comp'+index"
            :src="item.picture"
            class="comp"
            :style="{'width':`${item.width*multiple}px`,'height':`${item.height*multiple}px`, 'top':`${item.top*multiple}px`, 'left':`${item.left*multiple}px`}"
          />
          <!-- 文本 -->
          <div
            v-if="item.type==='TEXT'"
            :key="'comp'+index"
            class="comp"
            :style="{'font-size':`${item.font_size*multiple}px`,'line-height':`${item.font_size*multiple}px`, 'top':`${item.top*multiple}px`, 'left':`${item.left*multiple}px`, 'white-space': 'nowrap', 'border': '1px solid #ccc'}"
          ><span :style="{'zoom':`${item.zoom}`}">{{ item.text }}</span></div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
const defaultPageData = {
  // name: '', // 模板名称
  print_mode: 2, // 一页几码
  size: '62*25', // 纸张尺寸（宽*高）
  space: 2, // 码水平间距（mm）
  gap: 2, // 码垂直间距（mm）
  unit: [
    {
      type: 'QRCODE',
      top: 0,
      left: 0,
      width: 15,
      height: 15,
      picture: 'https://8899-city.oss-cn-shenzhen.aliyuncs.com/code/qrcode_demo.bmp'
    },
    {
      type: 'TEXT',
      top: 20,
      left: 0,
      // width: 30, // ?
      // height: 5, // ?
      font_size: 2,
      zoom: 1,
      // line_height: 5, // ?
      goods_field: '',
      text: '打印文字测试'
    },
    {
      type: 'PIC',
      top: 0,
      left: 32,
      width: 30,
      height: 25,
      picture: 'http://czdongsheng.oss-cn-shenzhen.aliyuncs.com/ATTRIBUTE/20210203/58c6179c51a067c1f8ca00174ce8af4c.bmp'
    }
  ]
}

export default {
  data() {
    return {
      multiple: 5 // px与mm转化倍数，统一为5，勿修改
    }
  },
  props: {
    // 纸张数据
    mouldData: {
      type: Object,
      default: () => {
        return defaultPageData
      }
    }
  },
  computed: {
    oneCodeW() {
      return (this.pageW - this.mouldData.space * (this.mouldData.print_mode - 1)) / this.mouldData.print_mode
    },
    pageW() {
      const sizeArr = this.mouldData.size.split('*')
      return parseFloat(sizeArr[0]) || 0
    },
    pageH() {
      const sizeArr = this.mouldData.size.split('*')
      return parseFloat(sizeArr[1]) || 0
    }
  }
}
</script>
<style scoped>
.comp {
  position: absolute;
  overflow: hidden;
  z-index: 1;
  user-select: none;
}
.print-box {
  display: inline-block;
  overflow: auto;
  box-sizing: border-box;
  padding: 20px;
  background: rgba(0, 0, 0, 0.1);
  max-width: 100%;
}
.print-des {
  margin-bottom: 10px;
  line-height: 20px;
}
</style>
